import { __exports as i } from "./contact-channels227.js";
import s from "react";
import { __require as m } from "./contact-channels228.js";
var n;
function R() {
  return n ? i : (n = 1, function(e) {
    var u = i && i.__importDefault || function(t) {
      return t && t.__esModule ? t : { default: t };
    };
    Object.defineProperty(e, "__esModule", { value: !0 }), e.returnFirstArg = e.canTextBeChildOfNode = e.ELEMENTS_WITH_NO_TEXT_CHILDREN = e.PRESERVE_CUSTOM_ATTRIBUTES = void 0, e.isCustomComponent = _, e.setStyleProp = E;
    var a = s, f = u(m()), o = /* @__PURE__ */ new Set([
      "annotation-xml",
      "color-profile",
      "font-face",
      "font-face-src",
      "font-face-uri",
      "font-face-format",
      "font-face-name",
      "missing-glyph"
    ]);
    function _(t, r) {
      return t.includes("-") ? !o.has(t) : !!(r && typeof r.is == "string");
    }
    var l = {
      reactCompat: !0
    };
    function E(t, r) {
      if (typeof t == "string") {
        if (!t.trim()) {
          r.style = {};
          return;
        }
        try {
          r.style = (0, f.default)(t, l);
        } catch {
          r.style = {};
        }
      }
    }
    e.PRESERVE_CUSTOM_ATTRIBUTES = Number(a.version.split(".")[0]) >= 16, e.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
      "tr",
      "tbody",
      "thead",
      "tfoot",
      "colgroup",
      "table",
      "head",
      "html",
      "frameset"
    ]);
    var c = function(t) {
      return !e.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(t.name);
    };
    e.canTextBeChildOfNode = c;
    var T = function(t) {
      return t;
    };
    e.returnFirstArg = T;
  }(i), i);
}
export {
  R as __require
};
//# sourceMappingURL=contact-channels208.js.map
